/**
 * Page header (title + Add button) for Organisation Management.
 *
 * Extracted from OrganisationManagementPage.tsx (Sub-PR 6.3).
 */

import { useTranslation } from 'react-i18next'
import { Building2, Plus } from 'lucide-react'

interface OrganisationPageHeaderProps {
  onAdd: () => void
}

export function OrganisationPageHeader({ onAdd }: OrganisationPageHeaderProps): React.ReactElement {
  const { t } = useTranslation('admin')
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-3">
        <div className="rounded-lg bg-blue-100 p-2 dark:bg-blue-900">
          <Building2 className="h-6 w-6 text-blue-600 dark:text-blue-400" />
        </div>
        <div>
          <h1 className="text-2xl font-semibold text-stone-900 dark:text-stone-100">
            {t('organisations.title')}
          </h1>
          <p className="text-sm text-stone-500 dark:text-stone-400">
            {t('organisations.description')}
          </p>
        </div>
      </div>
      <button
        onClick={onAdd}
        className="flex items-center gap-2 rounded-lg bg-[#4e5e82] px-4 py-2 text-white transition-colors hover:bg-[#5c6e94]"
      >
        <Plus className="h-4 w-4" />
        {t('organisations.addOrganisation')}
      </button>
    </div>
  )
}
